import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleNavigationVisible } from 'ui/actions';

export const useNavSuppressed = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(toggleNavigationVisible(false));
    return () => {
      dispatch(toggleNavigationVisible(true));
    };
  }, [dispatch]);
};

export const useIsNavigationVisible = () => useSelector(state => state.ui.navigationVisible);

export const useIsSideBarClosed = () => useSelector(state => state.ui.closeSidebar);

export const useIsSideBarVisible = () => useSelector(state => state.ui.showSideBar);

export const useDebouncedValue = (initialValue, delay = 500) => {
  const [value, setValue] = useState(initialValue);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    const handleDebounce = () => {
      setValue(initialValue);
      setTimeoutId(null);
    };

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const newTimeoutId = setTimeout(handleDebounce, delay);

    setTimeoutId(newTimeoutId);

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [initialValue, delay]);

  return value;
};

export default useNavSuppressed;
